import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import UserService from "../Services/UserList";
import SidebarNavigation from "./SidebarNavigation";
import MainLayout from "./admin/MainLayout";
import { useNavigate } from "react-router-dom";
import { fetchRegion, fetchState, fetchUserOption } from "../redux/slices/clientSlice";
import { useDispatch, useSelector } from "react-redux";

export default function EditUserList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { stateData, regionData, userOption } = useSelector((state) => state.client);

  const { id } = useParams();
  // const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    user_type: "Company",
    name: "",
    last_name: "",
    email: "",
    city: "",
    state: "",
    is_active: "",
    emp_code: "",
    designation: "",
    role_id: "",
    salesEnablers: "",
    channel: "",
  });

  const [channels, setChannels] = useState([]);

  useEffect(() => {
    dispatch(fetchUserOption());
    dispatch(fetchRegion());

    const fetchChannelsList = async () => {
      try {
        const response = await UserService.GetChannels();
        if (response && response.status && response.data) {
          setChannels(response.data);
        }
      } catch (error) {
        console.error("Error fetching channels:", error);
      }
    };
    fetchChannelsList();
  }, []);

  useEffect(() => {
    dispatch(fetchState({ id: regionData?.find(r => r.name === formData.city)?.id }));
  }, [formData.city]);

  const [users, setUsers] = useState([]);
  useEffect(() => {
    userlistapi();
  }, []);
  const userlistapi = async () => {
    try {
      const response = await UserService.EditUser(id);
      setFormData(response.data);
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "warning",
        text: error,
        timer: 3000,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.user_type === "Company") {
      if (!formData.name || !formData.email || !formData.emp_code || !formData.city || !formData.state || !formData.role_id) {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          text: "Please fill all required fields for Employee",
          timer: 3000,
        });
        return;
      }
    } else if (formData.user_type === "Dealer") {
      if (!formData.name || !formData.email || !formData.emp_code || !formData.city || !formData.state) {
        Swal.fire({
          icon: "warning",
          title: "Validation Error",
          text: "Please fill all required fields for Dealer",
          timer: 3000,
        });
        return;
      }
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Email",
        text: "Please enter a valid email address",
        timer: 3000,
      });
      return;
    }

    try {
      const response = await UserService.UpdateUser(formData);
      if (response) {
        Swal.fire({
          icon: "success",
          title: "user",
          text: "user update successfully",
          timer: 3000,
        });
        navigate("/admin/userlist");
      }
    } catch (error) {
      // console.log(error.errors);
      Swal.fire({
        icon: "warning",
        title: "warning",
        text: error.errors,
        timer: 3000,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
      };

      if (name === "user_type") {
        updatedData = {
          ...updatedData,
         role_id: value === "Dealer" ? "7" : "",
          designation: "",
          salesEnablers: "",
        };
      }

      if (name === "role_id") {
        updatedData = {
          ...updatedData,
          designation: "",
          salesEnablers: "",
        };
      }

      return updatedData;
    });
  };

  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const response = await UserService.UserList();
        setUsers(response.data.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
      }
    };

    fetchUserList();
  }, [formData.role_id]);


  const filteredDesignations = userOption?.filter((item) => item.role_id == 2);
  const salesEnablerOpt = userOption?.filter((item) => item.role_id == 6);

  return (
    <MainLayout>
      <div className="">
        <form
          onSubmit={handleSubmit}
          className="relative bg-gradient-to-br h-auto from-blue-50 to-indigo-100 shadow-lg border border-gray-200 rounded-2xl p-8 max-w-4xl mx-auto"
        >
          <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
              <div className="space-y-1">
                <label
                  htmlFor="user_type"
                  className="block text-sm font-medium text-gray-600"
                >
                  User Type *
                </label>
                <div className="relative group">
                  <select
                    id="user_type"
                    name="user_type"
                    value={formData.user_type}
                    onChange={handleChange}
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  >
                    <option value="Company">Company</option>
                    <option value="Dealer">Dealer</option>
                  </select>
                </div>
              </div>
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  First Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter First Name"
                  className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-800 focus:ring-4 focus:ring-indigo-400 focus:outline-none transition-shadow duration-300 shadow-sm placeholder:text-gray-400 sm:text-base"
                />
              </div>

              {/* Last Name */}
              <div>
                <label
                  htmlFor="last_name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  name="last_name"
                  id="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Enter Last Name"
                  className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-800 focus:ring-4 focus:ring-indigo-400 focus:outline-none transition-shadow duration-300 shadow-sm placeholder:text-gray-400 sm:text-base"
                />
              </div>

              {/* Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@domain.com"
                  className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-800 focus:ring-4 focus:ring-indigo-400 focus:outline-none transition-shadow duration-300 shadow-sm placeholder:text-gray-400 sm:text-base"
                />
              </div>

              <div className="space-y-1">
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-600"
                >
                  Phone
                </label>
                <div className="relative group">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="1234567890"
                    maxLength={10}
                    pattern="[0-9]{10}"
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  />
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div>
                <label
                  htmlFor="empCode"
                  className="block text-sm font-medium text-gray-700"
                >
                  {formData?.user_type === "Company" ? "Employee Code *" : "GST No.*"}
                </label>
                <input
                  type="text"
                  name="emp_code"
                  id="emp_code"
                  value={formData.emp_code}
                  onChange={handleChange}
                  placeholder={formData.user_type === 'Dealer' ? "Enter GST No." : "Enter Employee Code"}
                  className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-800 focus:ring-4 focus:ring-indigo-400 focus:outline-none transition-shadow duration-300 shadow-sm placeholder:text-gray-400 sm:text-base"
                />
              </div>

              {/* City */}
              <div>
                <label
                  htmlFor="city"
                  className="block text-sm font-medium text-gray-700"
                >
                  Region
                </label>
                <select
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                >
                  <option value="">Select Region</option>
                  {regionData?.map(region => (
                    <option key={region.id} value={region.name}>
                      {region.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* State */}
              <div>
                <label
                  htmlFor="state"
                  className="block text-sm font-medium text-gray-700"
                >
                  State
                </label>
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                >
                  <option value="">Select State</option>
                  {stateData?.map(s => (
                    <option key={s.id} value={s.name}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Channel */}
              <div className="space-y-1">
                <label
                  htmlFor="channel"
                  className="block text-sm font-medium text-gray-600"
                >
                  Channel Name
                </label>
                <div className="relative group">
                  <select
                    id="channel"
                    name="channel"
                    value={formData.channel || ""}
                    onChange={handleChange}
                    className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                  >
                    <option value="">Select Channel</option>
                    {channels?.map((channel) => (
                      <option key={channel.id} value={channel.id}>
                        {channel.channel_name}
                      </option>
                    ))}
                  </select>
                  <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              {formData?.user_type == 'Company' &&
                <div className="space-y-1">
                  <label
                    htmlFor="Role"
                    className="block text-sm font-medium text-gray-600"
                  >
                    Role
                  </label>
                  <div className="relative group">
                    <select
                      id="role_id"
                      name="role_id"
                      value={formData.role_id}
                      onChange={handleChange}
                      className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                    >
                      <option value="">Select Role</option>
                      <option value="2">IC</option>
                      <option value="3">BSP</option>
                      <option value="4">DSP</option>
                      <option value="5">BD</option>
                      <option value="6">Sales Enabler</option>
                      <option value="8">Studio</option>
                    </select>

                    <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              }
              {(formData.role_id == 3 || formData.role_id == 4) && (
                <div className="space-y-1">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-600"
                  >
                    IC
                  </label>
                  <div className="relative group">
                    <select
                      id="designation"
                      name="designation"
                      // value={formData.designation}
                      value={
                        filteredDesignations?.find(
                          (d) => d.name === formData.designation
                        )?.id || formData.designation
                      }
                      onChange={handleChange}
                      className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                    >
                      <option value="">Select IC</option>
                      {filteredDesignations?.map((designation) => (
                        <option key={designation.id} value={designation.id}>
                          {designation.name} {designation.last_name ? designation.last_name : ''} {designation.emp_code}
                        </option>
                      ))}
                    </select>

                    <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              )}
              {(formData.role_id == 2) && (
                <div className="space-y-1">
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium text-gray-600"
                  >
                    Sales Enabler
                  </label>
                  <div className="relative group">
                    <select
                      id="salesEnablers"
                      name="salesEnablers"
                      value={
                        salesEnablerOpt?.find(
                          (d) => d.name === formData.salesEnablers
                        )?.id || formData.salesEnablers
                      }
                      onChange={handleChange}
                      className="mt-1 w-full px-4 py-3 rounded-lg shadow-sm border border-gray-200 focus:ring-2 focus:ring-indigo-300 focus:border-transparent transition-all duration-200 group-hover:border-indigo-200"
                    >
                      <option value="">Select Sales Enabler</option>
                      {salesEnablerOpt?.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name} {s.last_name ? s.last_name : ''} {s.emp_code}
                        </option>
                      ))}
                    </select>

                    <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-indigo-500">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              )}
              {/* Status */}
              <div>
                <label
                  htmlFor="is_active"
                  className="block text-sm font-medium text-gray-700"
                >
                  Status
                </label>
                <select
                  name="is_active"
                  id="is_active"
                  value={formData.is_active}
                  onChange={handleChange}
                  className="mt-2 block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-800 focus:ring-4 focus:ring-indigo-400 focus:outline-none transition-shadow duration-300 shadow-sm sm:text-base"
                >
                  <option value="0">Deactive</option>
                  <option value="1">Active</option>
                </select>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-center items-center space-x-6 mt-6">
              <button
                type="submit"
                className="px-8 py-3 rounded-lg bg-gradient-to-r from-indigo-500 to-purple-500 text-white font-semibold shadow-lg hover:from-indigo-600 hover:to-purple-600 focus:ring-4 focus:ring-indigo-300 focus:outline-none transition duration-300"
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => navigate("/admin/userlist")}
                className="px-8 py-3 rounded-lg bg-gray-100 border border-gray-300 text-gray-700 font-semibold shadow-lg hover:bg-gray-200 focus:ring-4 focus:ring-gray-300 focus:outline-none transition duration-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </MainLayout>
  );
}
